<template>
  <div class="roleBox">
    <div class="myTop">
      <el-breadcrumb style="line-height: 60px;margin-left: 30px;" separator="/">
        <el-breadcrumb-item :to="{ path: '/equipmentManager/equipmentTypeManager' }">设备管理</el-breadcrumb-item>
        <el-breadcrumb-item>报修处理</el-breadcrumb-item>
      </el-breadcrumb>

      <el-dialog title="修改信息" :visible.sync="dialogVisible" width="30%">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="设备位号" prop="num">
            <el-select v-model="ruleForm.num" style="width: 260px;" placeholder="设备位号">
              <el-option label="111" value="11"></el-option>
              <el-option label="222" value="22"></el-option>
              <el-option label="333" value="33"></el-option>
              <el-option label="444" value="44"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="设备名称" prop="name">
            <el-input style="width: 260px;" v-model="ruleForm.name"></el-input>
          </el-form-item>
          <el-form-item label="检修专业" prop="region">
            <el-select v-model="ruleForm.region" style="width: 260px;" placeholder="请选择检修专业">
              <el-option label="压力容器" value="压力容器"></el-option>
              <el-option label="运作泵机" value="运作泵机"></el-option>
              <el-option label="管道维修" value="管道维修"></el-option>
              <el-option label="设备维修" value="设备维修"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属区域" prop="area">
            <el-select v-model="ruleForm.area" style="width: 260px;" placeholder="请选择所属区域">
              <el-option label="顺酐车间" value="顺酐车间"></el-option>
              <el-option label="助剂车间" value="助剂车间"></el-option>
              <el-option label="油品车间" value="油品车间"></el-option>
              <el-option label="设备科" value="设备科"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="维修内容" prop="desc">
            <el-input style="width: 260px;" type="textarea" v-model="ruleForm.desc"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitForm('ruleForm',0,'add')">保存</el-button>
          <el-button type="primary" @click="submitForm('ruleForm',1,'add')">保存并申报</el-button>
          <el-button @click="dialogVisible = false">取 消</el-button>
        </span>
      </el-dialog>
    </div>

    <!-- 顶部信息栏 -->
    <div class="roleHead">
      <!-- 时间选择 -->
      <el-time-picker
        is-range
        v-model="value1"
        range-separator="～"
        start-placeholder="下达时间开始"
        end-placeholder="下达时间截止"
        placeholder="选择时间范围"
      ></el-time-picker>

      <!-- 收索框 -->
      <el-input placeholder="单位/位号/名称" v-model="inputVal" class="myInput">
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>
    </div>

    <!-- 表格内容 -->
    <el-table :data="tableData" stripe style="width: 100%;padding:10px 0 0 20px;">
      <el-table-column prop="errorNo" label="编号">
        <template slot-scope="scope">
          <el-popover trigger="hover" placement="top">
            <div slot="reference" class="name-wrapper">
              <el-link
                type="primary"
                @click="handelShowInfo(scope.row.id,scope.row)"
              >{{scope.row.errorNo}}</el-link>
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="deviceLedger" label="设备位号"></el-table-column>

      <el-table-column prop="deviceName" label="设备名称"></el-table-column>

      <el-table-column prop="overhaulProfession" label="检修专业"></el-table-column>

      <el-table-column prop="area" label="所属区域"></el-table-column>

      <el-table-column prop="gmtCreate" label="申报时间" sortable width="226px"></el-table-column>

      <el-table-column prop="status" label="状态" width="190px">
        <template slot-scope="scope">
          <el-popover trigger="hover" placement="top">
            <div slot="reference" class="name-wrapper">
              <el-tag
                effect="dark"
                :type="scope.row.setTagType"
                size="medium"
              >{{scope.row.setTagWord}}</el-tag>
            </div>
          </el-popover>
        </template>
      </el-table-column>

      <el-table-column prop="process" label="进度" width="240px">
        <template slot-scope="scope">
          <el-popover trigger="hover" placement="top">
            <div slot="reference" class="name-wrapper">
              {{scope.row.setType}}
              <el-progress :percentage="scope.row.progress" :status="scope.row.setType"></el-progress>
            </div>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="block" style="position: relative;">
      <el-pagination
        style="position: absolute; right: 0; top: 0;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <leftInfo
      v-if="isShowLeft"
      :currentid="currentId"
      :currentrow="currentRow"
      @ifClose="isShowLeft=false"
    />
  </div>
</template>

<script>
import leftInfo from "./comps/leftInfo";

import Vue from "vue";
export default {
  data() {
    return {
      isVisible: false,
      currentId: "",
      currentRow: {},
      isShowLeft: false,
      ifadd: true,
      changeId: "",
      word: "",
      ruleForm: {
        num: "",
        name: "",
        region: "",
        area: "",
        desc: "",
      },
      rules: {
        name: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          {
            min: 1,
            max: 20,
            message: "长度在 1 到 20 个字符",
            trigger: "blur",
          },
        ],
        region: [
          { required: true, message: "请选择检修设备", trigger: "change" },
        ],
        area: [
          { required: true, message: "请选择所属区域", trigger: "change" },
        ],
        desc: [{ required: true, message: "请填写维修内容", trigger: "blur" }],
      },

      dialogVisible: false,
      hackReset: true,
      currentPage: "",
      total: 10,
      inputVal: "",
      value1: [new Date(2016, 9, 10, 8, 40), new Date(2016, 9, 10, 9, 40)],
      tableData: [
        {
          errorNo: "",
          area: "",
          deviceLedger: "",
          deviceName: "",
          overhaulProfession: "",
          area: "",
          gmtCreate: "",
          status: "",
          process: 20,
        },
      ],
      currentPage: 1,
      sizePage: 10,
    };
  },
  created() {
    this.getNo();
    this.deptGetInfo(1, 10);
  },
  components: {
    leftInfo,
  },
  methods: {
    handleSizeChange(val) {
      this.sizePage = val;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.deptGetInfo(this.currentPage, this.sizePage);
    },
    open() {
      this.dialogVisible = true;
      this.ifadd = true;
    },
    //查看具体信息
    handelShowInfo(id, row) {
      this.isShowLeft = true;
      this.currentId = id;
      this.currentRow = row;
      // console.log(id, row);
    },
    handleChange(id, row) {
      this.ifadd = false;
      this.changeId = id;
      this.dialogVisible = true;
      (this.ruleForm.num = row.errorNo),
        (this.ruleForm.name = row.deviceName),
        (this.ruleForm.area = row.area),
        (this.ruleForm.region = row.overhaulProfession),
        (this.ruleForm.desc = row.content);
    },
    //获取所有的设备位号
    getNo() {
      this.componentsMoudel.httpRequest
        .getRequestHander(this.componentsMoudel.getData("urls").getReportNo)
        .openLoad()
        .startGet()
        .then((res) => {
          // console.log(res);
        });
    },
    submitForm(formName, status, type) {
      this.$refs[formName].validate((valid) => {
        //新增记录
        if (this.ifadd) {
          if (valid) {
            let arr = this.$refs[formName].$options.propsData.model;
            let formdata = new FormData();
            formdata.append("deviceLedger", arr.num);
            formdata.append("deviceName", arr.name);
            formdata.append("overhaulProfession", arr.region);
            formdata.append("area", arr.area);
            formdata.append("status", status);
            formdata.append("content", arr.desc);
            this.componentsMoudel.httpRequest
              .getRequestHander(this.componentsMoudel.getData("urls").addReport)
              .openLoad()
              .startPost(formdata)
              .then((res) => {
                if (res.result == "success") {
                  this.$message({
                    showClose: true,
                    message: "添加成功",
                    type: "success",
                  });
                }
              });
          } else {
            // console.log("error submit!!");
            return false;
          }
        } else {
          //修改记录
          if (valid) {
            let arr = this.$refs[formName].$options.propsData.model;
            let formdata = new FormData();
            formdata.append("deviceLedger", arr.num);
            formdata.append("deviceName", arr.name);
            formdata.append("overhaulProfession", arr.region);
            formdata.append("area", arr.area);
            formdata.append("status", status);
            formdata.append("content", arr.desc);
            formdata.append("id", this.changeId);
            this.componentsMoudel.httpRequest
              .getRequestHander(
                this.componentsMoudel.getData("urls").changeReport
              )
              .openLoad()
              .startPost(formdata)
              .then((res) => {
                if (res.result == "success") {
                  this.$message({
                    showClose: true,
                    message: "修改成功",
                    type: "success",
                  });
                }
              });
          } else {
            // console.log("error submit!!");
            return false;
          }
        }
      });
    },
    //获取故障报修信息
    deptGetInfo(page, limit) {
      const that = this;
      let formdata = new FormData();
      formdata.append("curPage", page);
      formdata.append("limit", limit);
      this.componentsMoudel.httpRequest
        .getRequestHander(this.componentsMoudel.getData("urls").repaiReport)
        .openLoad()
        .startPost(formdata)
        .then((res) => {
          this.tableData = res.body.data;
          this.total = res.body.data.length;
          this.tableData.forEach((item, index) => {
            if (item.progress < 50) {
              this.tableData[index].setType = "exception";
            } else if (item.progress > 50 && item.progress < 80) {
              this.tableData[index].setType = "warning";
            } else {
              this.tableData[index].setType = "success";
            }

            if (item.status == 0) {
              this.tableData[index].setTagWord = "已创建";
              this.tableData[index].setTagType = "warning";
            } else if (item.status == 1) {
              this.tableData[index].setTagWord = "已申报";
              this.tableData[index].setTagType = "";
            } else if (item.status == 2) {
              this.tableData[index].setTagWord = "已转工单";
              this.tableData[index].setTagType = "info";
            } else if (item.status == 3) {
              this.tableData[index].setTagWord = "已驳回";
              this.tableData[index].setTagType = "danger";
            } else {
              this.tableData[index].setTagWord = "已维修";
              this.tableData[index].setTagType = "success";
            }
          });
          this.tableData.map((item) => {
            item.progress = item.progress * 1;
          });
        });
    },
  },
};
</script>

<style scoped>
.roleBox {
  padding: 8px;
}
.el-menu-demo {
  padding: 10px 0 0 20px;
}
.margin {
  margin-bottom: 10px;
}
.el-input {
  width: 100px !important;
}
.roleHead {
  margin-bottom: 10px;
  position: relative;
}
.myInput {
  width: 200px !important;
  position: absolute;
  right: 0;
  top: 0;
}
.myTop {
  background-color: #ffffff;
  width: 89%;
  height: 60px;
  position: absolute;
  top: 0;
  right: 0;
}
.myBtn {
  position: absolute;
  top: 10px;
  right: 30px;
}
.el-message-box__content {
  height: 1000px !important;
}
</style>
